/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {UserModelListService} from '../../common/user-model-list.service';
import {ProfessionalLicense} from './professional-license.model';
import {Service} from '../../common/service.class';

@Injectable()
export class ProfessionalLicenseService extends UserModelListService<ProfessionalLicense> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'professionalLicense', ProfessionalLicense);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/professional/professional-license.service.ts